import React, { useState, useEffect } from 'react';
// import styles from './AdvancedEnvironmentalSuperfundNonNPL.module.scss';
import styles from '../../../BasicCleanupsFilter/BasicCleanupsFilter.module.scss';
import { CalciteCheckbox } from '@esri/calcite-components-react';

const firstOptions = {
  "Under Control" : {
     param: "SF_EI_HE_CODE='Y' AND MAP_SYMBOL_CODE LIKE '%SN%'",
     isIncluded: false,
     objectIds: null
   },
  "Not Under Control" : {
     param: "SF_EI_HE_CODE='N' AND MAP_SYMBOL_CODE LIKE '%SN%",
     isIncluded: false,
     objectIds: null
   },
  "No Control Information Reported" : {
     param: "SF_EI_HE_CODE='U' AND MAP_SYMBOL_CODE LIKE '%SN%'",
     isIncluded: false,
     objectIds: null
   }
 };
 const secondOptions = {
   "Under Control" : {
     param: "SF_EI_GM_CODE='Y' AND MAP_SYMBOL_CODE LIKE '%SN%'",
     isIncluded: false,
     objectIds: null
   },
  "Not Under Control" : {
     param: "SF_EI_GM_CODE='N' AND MAP_SYMBOL_CODE LIKE '%SN%'",
     isIncluded: false,
     objectIds: null
   },
  "No Control Information Reported" : {
     param: "SF_EI_GM_CODE='U' AND MAP_SYMBOL_CODE LIKE '%SN%'",
     isIncluded: false,
     objectIds: null
   }
 };
const AdvancedEnvironmentalSuperfundNonNPL = (props) => {
  const [firstBoxSectionDivs, setFirstBoxSectionDivs] = useState<Array<any>>([]);
  const [secondBoxSectionDivs, setSecondBoxSectionDivs] = useState<Array<any>>([]);

  const toggleParam = async ([firstOrSecond, key]) => {
    if (firstOrSecond === 'first') {
      firstOptions[key].isIncluded = !firstOptions[key].isIncluded;
    } else if (firstOrSecond === 'second') {
      secondOptions[key].isIncluded = !secondOptions[key].isIncluded;
    }
    passUpdatedParams();
  }

  const passUpdatedParams = () => { 
    let paramArray: Array<string> = [];
    for (let option in firstOptions) {
      if (firstOptions[option].isIncluded === true) {
        paramArray.push(firstOptions[option].param)
      }
    }
    for (let option in secondOptions) {
      if (secondOptions[option].isIncluded === true) {
        paramArray.push(secondOptions[option].param)
      }
    }
    // update the parameter stored in the parent component
    props.updateSuperfundNonNPLParams(paramArray);
  }


  const buildCheckboxDivs = (clear?) => {
    let firstBoxes: Array<any> = [];
    let secondBoxes: Array<any> = [];

    if (clear) {
      for (let key in firstOptions) {
        firstOptions[key]["isIncluded"] = false;
        firstBoxes.push(
          <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
            <CalciteCheckbox name={firstOptions[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(["first", key]) }} />
            <label className={styles.CheckboxLabels}>{key}</label>
          </div>
        );
      }
      // do the same for the second set of options
      for (let key in secondOptions) {
        secondOptions[key]["isIncluded"] = false;
        secondBoxes.push(
          <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
            <CalciteCheckbox name={secondOptions[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(["second", key]) }} />
            <label className={styles.CheckboxLabels}>{key}</label>
          </div>
        );
      }
    } else {

      for (let key in firstOptions) {
        // clear button was not clicked, create checkboxes so that previously checked are still checked
        if (firstOptions[key]["isIncluded"] === true) {
          firstBoxes.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox checked name={firstOptions[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(["first", key]) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        } else {
          firstBoxes.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox name={firstOptions[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(["first", key]) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        }
      }
      // do the same for the second set of options
      for (let key in secondOptions) {
        // clear button was not clicked, create checkboxes so that previously checked are still checked
        if (secondOptions[key]["isIncluded"] === true) {
          secondBoxes.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox checked name={secondOptions[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(["second", key]) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        } else {
          secondBoxes.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox name={secondOptions[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(["second", key]) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        }
      }
    }

    passUpdatedParams();
    setFirstBoxSectionDivs(firstBoxes);
    setSecondBoxSectionDivs(secondBoxes);
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { buildCheckboxDivs(); }, [props.matchesAny]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { buildCheckboxDivs(true); }, [props.signalClear]);


  return (
    <div className={styles.Sections}>
      <div className={styles.SectionTitleDivs}>
        <label className={styles.FilterSectionLabels}>Human Exposures are: </label>
      </div>
      <div className={styles.CheckboxSectionDivs}>
        {firstBoxSectionDivs}
      </div>
      <div className={styles.SectionTitleDivs}>
        <label className={styles.FilterSectionLabels}>Groundwater Migration is: </label>
      </div>
      <div className={styles.CheckboxSectionDivs}>
        {secondBoxSectionDivs}
      </div>
    </div>
  )
}

export default AdvancedEnvironmentalSuperfundNonNPL;
